const drawers = qsa('.drawer')

if(drawers.length){
  drawers.forEach(drawer => {
    const title = qs('.drawer__title', drawer)
    drawer.style.height = `${title.offsetHeight}px`

    forceLayout()

    requestAnimationFrame(()=>{
      drawer.classList.add('is-ready')
    })

    function open(){
      drawer.style.height = `${drawer.scrollHeight}px`
      drawer.classList.add('drawer--open')
    }

    function close(){
      drawer.style.height = `${title.offsetHeight}px`
      drawer.classList.remove('drawer--open')
    }

    if(drawer.classList.contains('drawer--open')){
      open()
    } else {
      close()
    }

    if(drawer.classList.contains('drawer--shy')){
      window.addEventListener('drawer-toggle',evt => {
        if(evt.detail.el !== drawer) close()
      })
    }


    drawer.addEventListener('click', () => {
      let status = 'open'

      if(drawer.classList.contains('drawer--open')){
        if(drawer.classList.contains('drawer--shy')) return
        close()
        status = 'closed'
      } else {
        open()
      }

      const drawerEvent = new CustomEvent('drawer-toggle',{detail:{
        el: drawer,
        status,
      }})

      window.dispatchEvent(drawerEvent)
    })
  })

  let windowWidth = window.innerWidth

  function onResize(){
    if(typeof windowWidth === 'undefined' || window.innerWidth === windowWidth){
      return
    }
    windowWidth = window.innerWidth
    drawers.forEach(drawer => {
      const title = qs('.drawer__title', drawer)
      if(drawer.classList.contains('drawer--open')){
        drawer.style.height = `${drawer.scrollHeight}px`
      } else {
        drawer.style.height = `${title.offsetHeight}px`
      }
    })
  }

  window.addEventListener('resize', debounce(onResize))
}